export default `<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="UTF-8">
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Invoice</title>
  <style>
    .invoice-root *{
      all: revert;
      box-sizing: border-box;
    }
    .invoice-root {
      font-family: "Open Sans", sans-serif;
      font-size: 12px;
      color: #000;
      margin: 0;
      max-width: 800px;
      margin: auto;
      background-color: #f9f9f9;
    }

    .invoice-root .a4-container {
      position: relative;
      width: 100%;
      padding-top: 141.42%; /* 1:1.414 aspect ratio */
      background-color: white;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      overflow: hidden;
    }

    .invoice-root .a4-content {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: calc(100% - 40px);
      overflow: auto;
      padding: 16px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      box-sizing: border-box;
    }

    .invoice-root h1,
    .invoice-root h2,
    .invoice-root h3,
    .invoice-root h4 {
      font-family: "Space Mono", monospace;
      margin: 0;
      color: #000;
    }

    .invoice-root p {
      color: #3b3b3b;
      margin: 0;
    }

    .invoice-root h1 {
      color: #000;
      font-size: 42px;
      font-weight: bold;
      text-align: right;
    }

    .invoice-root .bold {
      font-weight: bold;
    }

    .invoice-root .flex {
      display: flex;
    }

    .invoice-root .document-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .invoice-root .header {
      display: flex;
      justify-content: space-between;
    }

    .invoice-root .divider {
      width: 100%;
      border-bottom: 1px solid #3b3b3b;
      margin-top: 8px;
      margin-bottom: 18px;
    }

    .invoice-root .invoice-info,
    .invoice-root .billing-info {
      flex: 1;
    }

    .invoice-root .billing-info:first-child {
      padding-right: 12px;
    }

    .invoice-root .billing-info:last-child {
      padding-left: 12px;
    }

    .invoice-root .intro-table-title {
      font-weight: bold;
      color: #3b3b3b;
      text-transform: uppercase;
      font-size: 12px;
    }

    .invoice-root .intro-table-title span {
      font-weight: 500;
    }

    .invoice-root .table {
      width: 100%;
      margin-top: 20px;
      border-collapse: collapse;
    }

    .invoice-root p {
      margin: 0 !important;
    }

    .invoice-root .table th {
      background-color: {{from.brandColor}};
      color: white;
      font-weight: bold;
      padding: 8px;
      letter-spacing: 1px;
      text-align: right;
    }

    .invoice-root .table th:first-child {
      text-align: left;
    }

    .invoice-root .table td {
      padding: 8px;
      border-bottom: 1px solid #ddd;
      text-align: right;
    }

    .invoice-root .table td:first-child {
      text-align: left;
    }

    .invoice-root .table .even {
      background-color: {{from.brandColorLight}};
    }

    .invoice-root .table .odd {
      background-color: #ffffff;
    }

    .invoice-root .text-right {
      text-align: right;
    }

    .invoice-root .summary-container {
      margin-top: 18px;
      display: flex;
    }

    .invoice-root .summary {
      display: flex;
      flex: 0 0 auto;
      margin-left: auto;
      padding: 8px;
      background-color: {{from.brandColorLight}};
    }

    .invoice-root .summary-left {
      text-align: left;
      margin-right: 36px;
    }

    .invoice-root .summary-right {
      text-align: right;
    }

    .invoice-root .summary .total {
      font-weight: bold;
      font-size: 16px;
      margin-top: 4px;
      margin-bottom: 0;
    }

    .invoice-root .payment-details {
    margin-top: 18px;
    }

    .invoice-root .cards {
      height: 50px;
      margin: 8px;
      display: flex;
      align-items: center;
    }

    .invoice-root .payment-method {
      width: 28px;
      margin-right: 10px;
    }

    .invoice-root .button {
      text-transform: uppercase;
      display: inline-block;
      padding: 12px 14px;
      background-color: #23dbb0;
      color: #fff;
      text-decoration: none;
      border-radius: 12px;
      margin-top: 10px;
      font-weight: bold;
      text-align: center;
      cursor: pointer;
      font-size: 14px;
    }

    .invoice-root .bank-details {
      margin-top: 18px;
    }

    .invoice-root .note {
      margin-top: 20px;
      font-size: 12px;
    }

    @media (max-width: 576px) {
      .invoice-root {
        font-size: 10px;
      }

      .invoice-root .logo-invoice-container {
        flex-direction: column !important;
        gap: 12px !important;
        align-items: flex-start !important;
      }

      .invoice-root .logo-invoice-container img {
        max-width: 60px !important;
        max-height: 45px !important;
      }

      .invoice-root .document-header {
        flex-direction: column;
        gap: 16px;
      }

      .invoice-root .invoice-title h1 {
        font-size: 28px;
        text-align: left;
      }
    }

    .invoice-root .signature-container {
      display: flex;
      justify-content: space-between;
      margin-top: 80px;
    }

  </style>
</head>

<body>
<div class="invoice-root">
<div class="a4-container">
  <div class="a4-content">
    <div class="invoice-content">
    <div class="document-header">
      <div class="invoice-info">
        <div class="logo-invoice-container" style="display: flex; align-items: flex-start; gap: 20px;">
          {{#if from.logoUrl}}
          <div style="flex-shrink: 0;">
            <img src="{{from.logoUrl}}" alt="{{from.name}} Logo" style="max-width: 80px; max-height: 60px; object-fit: contain;" />
          </div>
          {{/if}}
          <div>
            <p class="intro-table-title"><span>{{task.invoiceStatus}} #</span> {{task.reference}}</p>
            <p class="intro-table-title"><span>ISSUED ON</span> {{task.issuedAt}}</p>
            <p class="intro-table-title"><span>{{task.dueTitle}}</span> {{task.dueAt}}</p>
            {{#if task.frequencyPeriod}}
            <p class="intro-table-title"><span>PERIOD</span> {{task.frequencyPeriod}}</p>
            {{/if}}
          </div>
        </div>
      </div>
      <div class="invoice-title">
        <h1>{{task.documentTitle}}</h1>
      </div>
    </div>

    <div class="divider"></div>

    <div class="header">
      <div class="billing-info">
        <p class="intro-table-title">{{task.invoiceStatus}} TO</p>
        <p>
          {{to.name}}<br>
          {{#if to.taxNumber}}<span>ABN {{to.taxNumber}}<br></span>{{/if}}
          {{#if to.address}}
            {{to.address.address2}}{{#if to.address.address2}} {{/if}}{{to.address.address1}}<br>
            {{to.address.city}}{{#if to.address.city}}, {{/if}}
            {{to.address.stateCode}}{{#if to.address.stateCode}}, {{/if}}{{to.address.postalCode}}
          {{/if}}
          {{#if to.email}}<br><span>{{to.email}}</span>{{/if}}
          {{#if to.phone}}<br><span>{{to.phone}}</span>{{/if}}
        </p>
      </div>
      <div class="billing-info">
        <p class="intro-table-title text-right">{{task.invoiceStatus}} FROM</p>
        <p class="text-right">
          {{from.name}}<br>
          ABN {{from.taxNumber}}<br>
          {{#if from.address}}
            {{from.address.address2}}{{#if from.address.address2}} {{/if}}{{from.address.address1}}<br>
            {{from.address.city}}{{#if from.address.city}}, {{/if}}{{from.address.stateCode}}{{#if from.address.stateCode}}, {{/if}}{{from.address.postalCode}}<br>
          {{/if}}
          {{from.contact.email}}<br>
          {{from.contact.phone}}<br>
          {{from.website}}
        </p>
      </div>
    </div>

    <table class="table">
      <tr class="heading">
        <th>DESCRIPTION</th>
        <th>UNIT PRICE</th>
        <th>QTY</th>
        <th>GST</th>
        <th>AMOUNT</th>
      </tr>
      {{#each lineItem}}
      <tr class="{{#if (isEven @index)}}odd{{else}}even{{/if}}">
        <td>{{description}}</td>
        <td class="text-right">{{unitPrice}}</td>
        <td class="text-right">{{qty}}</td>
        <td class="text-right">{{gst}}</td>
        <td class="text-right">{{amount}}</td>
      </tr>
      {{/each}}
    </table>

    <div class="summary-container">
      <div class="summary">
        <div class="summary-left">
          <p>Subtotal:</p>
          <p>GST (10%):</p>
          <p class="total">TOTAL (AUD)</p>
        </div>
        <div class="summary-right">
          <p>{{subTotal}}</p>
          <p>{{totalGST}}</p>
          <p class="total">{{total}}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="footer">
    {{#ifEquals task.invoiceStatus "INVOICE"}}
      <div class="payment-details">
        <p><strong>PAYMENT DETAILS</strong></p>
        <div class="cards">
          <img src="/visa.png" alt="visa" class="payment-method">
          <img src="/mastercard.png" alt="visa" class="payment-method">
          <img src="/amex.png" alt="visa" class="payment-method">
          <svg height="50px" viewBox="0 -140 780 780" enable-background="new 0 0 780 500" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><path d="m293.2 348.73l33.359-195.76h53.358l-33.384 195.76h-53.333zm246.11-191.54c-10.569-3.966-27.135-8.222-47.821-8.222-52.726 0-89.863 26.551-90.181 64.604-0.297 28.129 26.515 43.822 46.754 53.185 20.771 9.598 27.752 15.716 27.652 24.283-0.133 13.123-16.586 19.115-31.924 19.115-21.355 0-32.701-2.967-50.225-10.273l-6.878-3.111-7.487 43.822c12.463 5.467 35.508 10.199 59.438 10.445 56.09 0 92.502-26.248 92.916-66.885 0.199-22.27-14.016-39.215-44.801-53.188-18.65-9.056-30.072-15.099-29.951-24.269 0-8.137 9.668-16.838 30.56-16.838 17.446-0.271 30.088 3.534 39.936 7.5l4.781 2.259 7.231-42.427m137.31-4.223h-41.23c-12.772 0-22.332 3.486-27.94 16.234l-79.245 179.4h56.031s9.159-24.121 11.231-29.418c6.123 0 60.555 0.084 68.336 0.084 1.596 6.854 6.492 29.334 6.492 29.334h49.512l-43.187-195.64zm-65.417 126.41c4.414-11.279 21.26-54.724 21.26-54.724-0.314 0.521 4.381-11.334 7.074-18.684l3.606 16.878s10.217 46.729 12.353 56.527h-44.293v3e-3zm-363.3-126.41l-52.239 133.5-5.565-27.129c-9.726-31.274-40.025-65.157-73.898-82.12l47.767 171.2 56.455-0.063 84.004-195.39-56.524-1e-3" fill="#0E4595"/><path d="m146.92 152.96h-86.041l-0.682 4.073c66.939 16.204 111.23 55.363 129.62 102.42l-18.709-89.96c-3.229-12.396-12.597-16.096-24.186-16.528" fill="#F2AE14"/></svg>
          <svg height="50px" viewBox="0 -9 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="57" height="39" rx="3.5" fill="white" stroke="#F3F3F3"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M21.2489 30.8906V32.3674V33.8443H20.6016V33.4857C20.3963 33.7517 20.0848 33.9186 19.6614 33.9186C18.8266 33.9186 18.1722 33.27 18.1722 32.3674C18.1722 31.4656 18.8266 30.8163 19.6614 30.8163C20.0848 30.8163 20.3963 30.9832 20.6016 31.2492V30.8906H21.2489ZM19.7419 31.4218C19.1816 31.4218 18.8387 31.8483 18.8387 32.3674C18.8387 32.8866 19.1816 33.3131 19.7419 33.3131C20.2773 33.3131 20.6387 32.905 20.6387 32.3674C20.6387 31.8299 20.2773 31.4218 19.7419 31.4218ZM43.1228 32.3674C43.1228 31.8483 43.4657 31.4218 44.026 31.4218C44.5621 31.4218 44.9228 31.8299 44.9228 32.3674C44.9228 32.905 44.5621 33.3131 44.026 33.3131C43.4657 33.3131 43.1228 32.8866 43.1228 32.3674ZM45.5338 29.7044V32.3674V33.8443H44.8858V33.4857C44.6804 33.7517 44.3689 33.9186 43.9455 33.9186C43.1107 33.9186 42.4563 33.27 42.4563 32.3674C42.4563 31.4656 43.1107 30.8163 43.9455 30.8163C44.3689 30.8163 44.6804 30.9832 44.8858 31.2492V29.7044H45.5338ZM29.2838 31.3914C29.7008 31.3914 29.9688 31.6509 30.0373 32.1079H28.4925C28.5616 31.6814 28.8225 31.3914 29.2838 31.3914ZM27.8138 32.3674C27.8138 31.4465 28.424 30.8163 29.2966 30.8163C30.1307 30.8163 30.7038 31.4465 30.7102 32.3674C30.7102 32.4537 30.7038 32.5344 30.6974 32.6143H28.4868C28.5802 33.1462 28.9601 33.3379 29.3771 33.3379C29.6758 33.3379 29.9938 33.2261 30.2433 33.0288L30.5605 33.5048C30.1991 33.8075 29.7885 33.9186 29.3401 33.9186C28.449 33.9186 27.8138 33.3068 27.8138 32.3674ZM37.1126 32.3674C37.1126 31.8483 37.4555 31.4218 38.0158 31.4218C38.5511 31.4218 38.9126 31.8299 38.9126 32.3674C38.9126 32.905 38.5511 33.3131 38.0158 33.3131C37.4555 33.3131 37.1126 32.8866 37.1126 32.3674ZM39.5228 30.8906V32.3674V33.8443H38.8755V33.4857C38.6695 33.7517 38.3587 33.9186 37.9352 33.9186C37.1004 33.9186 36.446 33.27 36.446 32.3674C36.446 31.4656 37.1004 30.8163 37.9352 30.8163C38.3587 30.8163 38.6695 30.9832 38.8755 31.2492V30.8906H39.5228ZM33.4569 32.3674C33.4569 33.2636 34.0857 33.9186 35.0452 33.9186C35.4936 33.9186 35.7923 33.8196 36.116 33.5663L35.8051 33.0472C35.5621 33.2205 35.3068 33.3131 35.026 33.3131C34.5091 33.3068 34.1292 32.9361 34.1292 32.3674C34.1292 31.7988 34.5091 31.4281 35.026 31.4218C35.3068 31.4218 35.5621 31.5144 35.8051 31.6877L36.116 31.1685C35.7923 30.9153 35.4936 30.8163 35.0452 30.8163C34.0857 30.8163 33.4569 31.4713 33.4569 32.3674ZM41.0177 31.2492C41.1859 30.9896 41.429 30.8163 41.8026 30.8163C41.9337 30.8163 42.1205 30.8411 42.2638 30.8969L42.0642 31.5024C41.9273 31.4465 41.7904 31.4281 41.6593 31.4281C41.2358 31.4281 41.0241 31.6997 41.0241 32.1885V33.8443H40.3761V30.8906H41.0177V31.2492ZM24.4505 31.1254C24.1389 30.9217 23.7098 30.8163 23.2364 30.8163C22.4822 30.8163 21.9967 31.1749 21.9967 31.762C21.9967 32.2437 22.3582 32.5407 23.024 32.6334L23.3298 32.6765C23.6848 32.7261 23.8524 32.8187 23.8524 32.9856C23.8524 33.2141 23.6157 33.3442 23.1737 33.3442C22.7253 33.3442 22.4017 33.2021 22.1835 33.0351L21.8784 33.5352C22.2334 33.7948 22.6818 33.9186 23.1673 33.9186C24.027 33.9186 24.5253 33.5168 24.5253 32.9545C24.5253 32.4353 24.1332 32.1637 23.4852 32.0711L23.1801 32.0272C22.9 31.9904 22.6754 31.9353 22.6754 31.7372C22.6754 31.5208 22.8871 31.3914 23.2421 31.3914C23.6221 31.3914 23.9899 31.5335 24.1703 31.6446L24.4505 31.1254ZM32.0184 31.2492C32.1859 30.9896 32.429 30.8163 32.8025 30.8163C32.9337 30.8163 33.1205 30.8411 33.2637 30.8969L33.0641 31.5024C32.9273 31.4465 32.7904 31.4281 32.6592 31.4281C32.2358 31.4281 32.0241 31.6997 32.0241 32.1885V33.8443H31.3768V30.8906H32.0184V31.2492ZM27.2784 30.8906H26.2198V29.9944H25.5654V30.8906H24.9616V31.4776H25.5654V32.8251C25.5654 33.5105 25.8334 33.9186 26.5991 33.9186C26.8799 33.9186 27.2036 33.8323 27.4089 33.6901L27.2221 33.1398C27.0289 33.2509 26.8172 33.3068 26.649 33.3068C26.3253 33.3068 26.2198 33.1087 26.2198 32.8123V31.4776H27.2784V30.8906ZM17.5997 31.9904V33.8443H16.9453V32.2005C16.9453 31.6997 16.7336 31.4218 16.2916 31.4218C15.8617 31.4218 15.563 31.6941 15.563 32.2069V33.8443H14.9086V32.2005C14.9086 31.6997 14.6912 31.4218 14.2613 31.4218C13.8186 31.4218 13.5321 31.6941 13.5321 32.2069V33.8443H12.8784V30.8906H13.5264V31.2548C13.7695 30.909 14.0803 30.8163 14.3982 30.8163C14.853 30.8163 15.1767 31.0144 15.382 31.3418C15.6564 30.9274 16.0485 30.8099 16.4285 30.8163C17.1513 30.8227 17.5997 31.2923 17.5997 31.9904Z" fill="#231F20"/>
            <path d="M34.0465 25.8715H24.2359V8.3783H34.0465V25.8715Z" fill="#FF5F00"/>
            <path d="M24.8583 17.1253C24.8583 13.5767 26.5328 10.4157 29.1405 8.37867C27.2336 6.88907 24.8269 5.99998 22.2114 5.99998C16.0194 5.99998 11 10.9809 11 17.1253C11 23.2697 16.0194 28.2506 22.2114 28.2506C24.8269 28.2506 27.2336 27.3615 29.1405 25.8719C26.5328 23.8349 24.8583 20.6739 24.8583 17.1253" fill="#EB001B"/>
            <path d="M47.2818 17.1253C47.2818 23.2697 42.2624 28.2506 36.0704 28.2506C33.4548 28.2506 31.0482 27.3615 29.1405 25.8719C31.7489 23.8349 33.4235 20.6739 33.4235 17.1253C33.4235 13.5767 31.7489 10.4157 29.1405 8.37867C31.0482 6.88907 33.4548 5.99998 36.0704 5.99998C42.2624 5.99998 47.2818 10.9809 47.2818 17.1253" fill="#F79E1B"/>
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" height="50px" viewBox="-150 -249.37925 1300 1496.2755"><path d="M0 0h997.517v538.49l-49.375 77.147 49.375 68.661v313.219H0v-507.63l30.859-35.488L0 420.454z" fill="#016fd0"/><path d="M193.64 695.099v-156.61h165.82l17.791 23.193 18.38-23.193h601.886V684.3s-15.74 10.643-33.945 10.8H630.295l-20.058-24.688V695.1h-65.73v-42.142s-8.979 5.882-28.39 5.882h-22.373v36.26h-99.52l-17.766-23.69-18.038 23.69zM0 420.454l37.393-87.177h64.668l21.22 48.833v-48.833h80.388l12.633 35.295 12.247-35.295h360.858v17.744s18.97-17.744 50.146-17.744l117.085.41 20.854 48.193v-48.603h67.273l18.515 27.683v-27.683h67.89v156.61h-67.89l-17.744-27.774v27.773h-98.838l-9.94-24.687h-26.57l-9.779 24.687h-67.028c-26.826 0-43.974-17.381-43.974-17.381v17.381H488.343L468.285 465.2v24.687H92.481L82.548 465.2H56.06l-9.86 24.686H0z" fill="#fff"/><path d="M50.628 352.584L.193 469.848h32.836l9.306-23.482h54.1l9.257 23.482h33.56L88.863 352.584zm18.66 27.29l16.49 41.034H52.75zm73.435 89.954V352.564l46.661.173 27.14 75.605 26.49-75.778h46.289v117.264h-29.316v-86.405l-31.076 86.405h-25.71l-31.162-86.405v86.405zm166.638 0V352.564h95.663v26.23h-66.038v20.058h64.495v24.688h-64.495v20.83h66.038v25.458zm112.636-117.244v117.264h29.316v-41.66h12.343l35.15 41.66h35.826l-38.574-43.203c15.831-1.336 32.161-14.923 32.161-36.018 0-24.676-19.368-38.043-40.984-38.043zm29.316 26.23h33.51c8.04 0 13.887 6.288 13.887 12.343 0 7.79-7.577 12.344-13.452 12.344h-33.945zm118.807 91.014h-29.933V352.564h29.933zm70.975 0h-6.46c-31.262 0-50.243-24.63-50.243-58.15 0-34.349 18.768-59.114 58.246-59.114h32.402v27.773h-33.586c-16.026 0-27.36 12.507-27.36 31.63 0 22.71 12.96 32.248 31.63 32.248h7.715zm63.792-117.244l-50.435 117.264h32.836l9.305-23.482h54.1l9.258 23.482h33.559l-50.387-117.264zm18.66 27.29l16.49 41.034h-33.029zm73.386 89.954V352.564h37.272l47.59 73.676v-73.676h29.317v117.264h-36.067l-48.796-75.604v75.604zM213.699 675.04V557.776h95.662v26.23h-66.038v20.059h64.495v24.687h-64.495v20.83h66.038v25.458zm468.748 0V557.776h95.662v26.23h-66.038v20.059h64.187v24.687H712.07v20.83h66.038v25.458zm-369.373 0l46.578-57.908-47.687-59.356H348.9l28.4 36.693 28.497-36.693h35.488l-47.06 58.632 46.663 58.632H403.96l-27.576-36.114-26.905 36.114zM444.37 557.796V675.06h30.087v-37.03h30.859c26.111 0 45.903-13.853 45.903-40.792 0-22.317-15.523-39.442-42.094-39.442zm30.087 26.52h32.498c8.436 0 14.465 5.17 14.465 13.5 0 7.826-5.999 13.501-14.561 13.501h-32.402zm89.491-26.54V675.04h29.316v-41.66h12.344l35.15 41.66h35.825l-38.573-43.202c15.83-1.336 32.16-14.924 32.16-36.019 0-24.676-19.368-38.043-40.984-38.043zm29.316 26.23h33.511c8.039 0 13.887 6.288 13.887 12.344 0 7.79-7.577 12.343-13.453 12.343h-33.945zm198.423 91.034v-25.458h58.671c8.681 0 12.44-4.692 12.44-9.837 0-4.93-3.747-9.913-12.44-9.913h-26.513c-23.045 0-35.88-14.04-35.88-35.121 0-18.803 11.753-36.935 46-36.935h57.088l-12.343 26.385h-49.375c-9.438 0-12.343 4.952-12.343 9.682 0 4.86 3.59 10.222 10.8 10.222h27.773c25.69 0 36.838 14.572 36.838 33.655 0 20.517-12.422 37.32-38.236 37.32zm107.597 0v-25.458h58.67c8.682 0 12.44-4.692 12.44-9.837 0-4.93-3.746-9.913-12.44-9.913h-26.512c-23.046 0-35.88-14.04-35.88-35.121 0-18.803 11.753-36.935 45.999-36.935h57.089l-12.344 26.385h-49.374c-9.438 0-12.344 4.952-12.344 9.682 0 4.86 3.59 10.222 10.801 10.222h27.773c25.69 0 36.838 14.572 36.838 33.655 0 20.517-12.422 37.32-38.236 37.32z" fill="#016fd0"/></svg>
        </div>
        <a class="button">View and Pay Online</a>
<!--        <a href="{{task.url}}" class="button">View and Pay Online</a>-->
        {{#if receivingAccount.routingNumber}}
          {{#if receivingAccount.number}}
            <div class="bank-details">
              <p>Name: <span class="bold">{{receivingAccount.accountName}}</span></p>
              <p>BSB: <span class="bold">{{receivingAccount.routingNumber}}</span></p>
              <p>Account Number: <span class="bold">{{receivingAccount.number}}</span></p>
              <p>Reference: <span class="bold">{{task.reference}}</span></p>
            </div>
          {{/if}}
        {{/if}}
      </div>
    {{/ifEquals}}

    {{#if task.notes}}
    <div class="note">
      <p><strong>NOTES</strong><br>{{task.notes}}</p>
    </div>
    {{/if}}


    {{#if task.signatureRequired}}
    <div class="signature-container">
      <div class="signature-field">
        <p>_________________________</p>
        <p>Signature of Quote Acceptance</p>
      </div>
      <div class="signature-field">
        <p>________________</p>
        <p>Date of Acceptance</p>
      </div>
    </div>
    {{/if}}

    </div>

  </div>
  </div>
</body>
</html>`;
